<form class="flex col" autocomplete="nope" #form="ngForm">
    @for (t4Box of t4Boxes(); track t4Box.id) {
        <mat-form-field>
            <mat-label>
                @if (t4BoxNotifications()[$index]) {
                    <mat-icon svgIcon="boldInfo" class="margin-right-1 text-color-error"></mat-icon>
                }
                <span [class.text-color-error]="t4BoxNotifications()[$index]">
                    {{
                        'payroll.taxForms.T4.employee.boxDescriptionFormat'
                            | translate: { code: t4Box.boxNumber, description: t4Box.description }
                    }}
                </span>
            </mat-label>
            @if (t4Box.boxNumber !== '45') {
                <input
                    type="text"
                    [(ngModel)]="t4()[t4Box.xmlNameCamel]"
                    name="{{ t4Box.xmlNameCamel }}"
                    #field="ngModel"
                    matInput
                    [appBackendT4Errors]="t4().errors[t4Box.xmlNameCamel]"
                />
            } @else {
                <mat-select
                    type="text"
                    [ngModel]="box45"
                    (ngModelChange)="box45 = $event; t4().emprDntlBenRptCd = $event"
                    name="{{ t4Box.xmlNameCamel }}"
                    #field="ngModel"
                    matInput
                    panelClass="mw-unset"
                    [appBackendT4Errors]="t4().errors[t4Box.xmlNameCamel]"
                >
                    @for (
                        code of 'payroll.dental-benefits.table.codeDescriptions' | translate | keyvalue;
                        track $index
                    ) {
                        <mat-option [value]="code.key">
                            <strong>
                                {{ 'payroll.dental-benefits.assign.title' | translate: { code: code.key } }}</strong
                            >
                            - {{ code.value }}
                        </mat-option>
                    }
                </mat-select>
            }
            @if (fields()[$index].invalid) {
                <mat-error>{{ fields()[$index].errors | formErrors }}</mat-error>
            }
        </mat-form-field>
    }
</form>
